export type { AdConsentState, PageAdConsent };
export { COOKIEBOT_CONSENT_EVENTS, readPageAdConsent, readCookiebotMarketingConsent };

type AdConsentState = "granted" | "denied";

interface PageAdConsent {
  // El estado por defecto (antes de que el visitante decida)
  initial: AdConsentState;
  // El de ahora mismo (el `update` del banner, si ya lo hubo)
  current: AdConsentState;
}

// Eventos con los que Cookiebot avisa de una respuesta del visitante
const COOKIEBOT_CONSENT_EVENTS = [
  "CookiebotOnConsentReady",
  "CookiebotOnAccept",
  "CookiebotOnDecline",
];

/**
 * El consentimiento de anuncios de la página para las etiquetas que no leen
 * el Consent Mode de Google por su cuenta (UET, Taboola): el estado inicial y
 * el actual. Primero el Consent Mode de Google (`google_tag_data.ics`, lo que
 * pone el banner a través de GTM: no hay API pública para leerlo); si no hay,
 * el de Cookiebot (sin respuesta del visitante = denegado). null si la página
 * no dice nada.
 */
function readPageAdConsent(): PageAdConsent | null {
  try {
    const entry = (
      window as unknown as {
        google_tag_data?: {
          ics?: {
            entries?: Record<string, { default?: unknown; update?: unknown }>;
          };
        };
      }
    ).google_tag_data?.ics?.entries?.["ad_storage"];
    if (entry && (entry.default !== undefined || entry.update !== undefined)) {
      const initial: AdConsentState =
        entry.default === false ? "denied" : "granted";
      const current: AdConsentState =
        entry.update !== undefined
          ? entry.update === true
            ? "granted"
            : "denied"
          : initial;
      return { initial, current };
    }
    const cookiebot = readCookiebotMarketingConsent();
    return cookiebot === null ? null : { initial: "denied", current: cookiebot };
  } catch {
    return null;
  }
}

// Lo que dice Cookiebot de las cookies de marketing; null si no está en la página.
function readCookiebotMarketingConsent(): AdConsentState | null {
  const cookiebot = (
    window as unknown as {
      Cookiebot?: {
        hasResponse?: unknown;
        consent?: { marketing?: unknown };
      };
    }
  ).Cookiebot;
  if (!cookiebot || typeof cookiebot !== "object") {
    return null;
  }
  return cookiebot.hasResponse === true && cookiebot.consent?.marketing === true
    ? "granted"
    : "denied";
}
